import type { CategoryId, GameEvent } from '../game/types'

import football from './football.json'
import nba from './nba.json'
import tennis from './tennis.json'
import f1 from './f1.json'

/*
 * Datasets live as plain JSON in this directory so they can be edited or
 * extended without touching any game code. Each file is an array of events:
 *
 *   { "id": "fb-1950-maracanazo",
 *     "title": "Uruguay stun Brazil at the Maracanã",
 *     "date": "1950-07-16",
 *     "blurb": "In the deciding match of the World Cup..." }
 *
 * "mixed" is derived automatically from all four sport pools.
 */

const football_ = football as GameEvent[]
const nba_ = nba as GameEvent[]
const tennis_ = tennis as GameEvent[]
const f1_ = f1 as GameEvent[]

export const POOL: Record<CategoryId, GameEvent[]> = {
  football: football_,
  nba: nba_,
  tennis: tennis_,
  f1: f1_,
  mixed: [...football_, ...nba_, ...tennis_, ...f1_],
}

/** Total number of events available per category (for display/debugging). */
export const POOL_SIZES: Record<CategoryId, number> = {
  football: POOL.football.length,
  nba: POOL.nba.length,
  tennis: POOL.tennis.length,
  f1: POOL.f1.length,
  mixed: POOL.mixed.length,
}
